import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import type { CheckInResponse } from '../lib/api.js'

/** Resumen de lealtad del comensal tras identificarse (opcional). */
export interface GuestLoyalty {
  contactId: string
  loyaltyPoints: number
  loyaltyVisits: number
  pointsEarned: number
  customerName: string
}

/** Estado del programa de lealtad del NEGOCIO (no del comensal). Gatea si se
 *  muestra el hook de "acumula puntos". null = aún no se consultó. */
export interface LoyaltyProgram {
  enabled: boolean
  pointsPerVisit: number
}

interface SessionState {
  session: CheckInResponse | null
  /** Lealtad acumulada — null mientras el comensal sea anónimo. */
  loyalty: GuestLoyalty | null
  /** El comensal ya descartó/usó la tarjeta de 'acumula puntos'. */
  loyaltyDismissed: boolean
  /** Programa de lealtad del negocio (enabled/pointsPerVisit) — null hasta cargar. */
  loyaltyProgram: LoyaltyProgram | null
  setSession: (s: CheckInResponse | null) => void
  setLoyalty: (l: GuestLoyalty | null) => void
  setLoyaltyProgram: (p: LoyaltyProgram | null) => void
  dismissLoyalty: () => void
  isExpired: () => boolean
  clear: () => void
}

export const useSessionStore = create<SessionState>()(
  persist(
    (set, get) => ({
      session: null,
      loyalty: null,
      loyaltyDismissed: false,
      loyaltyProgram: null,
      setSession: (s) => set({ session: s }),
      setLoyalty: (l) => set({ loyalty: l }),
      setLoyaltyProgram: (p) => set({ loyaltyProgram: p }),
      dismissLoyalty: () => set({ loyaltyDismissed: true }),
      isExpired: () => {
        const s = get().session
        if (!s) return true
        return Date.now() >= new Date(s.expiresAt).getTime()
      },
      clear: () => set({ session: null, loyalty: null, loyaltyDismissed: false, loyaltyProgram: null }),
    }),
    {
      name: 'dhk8-guest-session',
      // NO persistir `loyaltyProgram`: el flag enabled/pointsPerVisit debe leerse
      // FRESCO del backend en cada visita (Menu/CheckIn lo re-consultan). Antes se
      // cacheaba en localStorage y, tras apagar la lealtad, el guest rehidrataba el
      // estado viejo (enabled=true) y seguía mostrando "acumular puntos".
      partialize: (s) => ({
        session: s.session,
        loyalty: s.loyalty,
        loyaltyDismissed: s.loyaltyDismissed,
      }),
    },
  ),
)
